import { COMPARE_TYPES } from '@store/trends/base/reducer';
import { isEmpty } from 'lodash';

export const getFilterNameFn = (type) => {
  if (type === COMPARE_TYPES.dashboard) {
    return (filter) => filter.name;
  }
  // do not show all traffic text for trends mode
  // as filter are secondary to the primary filter on the page
  return (filter) => (isEmpty(filter.rule) ? '-' : filter.name);
};

export const getFilterKey = (filter, idx = -1) => {
  // TODO: add a fallback? worst case it will cause a forced re-render
  // shortId()
  const { name, meta = { cid: '-' } } = filter;
  return `${name}-${meta.cid}-${idx}`;
};
